import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

@Component({
  selector: 'etxe-property-owner-details-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderComponent],
  templateUrl: './property-owner-details-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyOwnerDetailsSkeletonComponent {}
